// extracted by mini-css-extract-plugin
export default {"note":"IncomeDisclaimerNote_note__IJffc"};